import { NORMALIZED_ZOOMED_OUT, setNormalizedZoomLevel } from './canvas';
import { COLORS } from './constants-colors';
import logger from './controllers/logger';
import { getZeroStaticEntity, setEntityPosition, setParent } from './entity';
import { v2 } from './helpers';
import { createImageEnt } from './image_entity';
import { initRoom } from './room';
import { setVisibilityState } from './simulate';
import { createAndAddLocalTextObject2 } from './text_object2/text_object2';
import {
  VisibilityState,
  type GameManager,
  type ImageEnt,
  type Room,
  type TextObject2,
} from './types';

let room: Room = null;

export function init(manager: GameManager) {
  room = initRoom(manager, 'wish collector', 'wishcollector1');
  setVisibilityState(room, VisibilityState.DEFAULT);

  setNormalizedZoomLevel(room.canvas, NORMALIZED_ZOOMED_OUT);

  room.width = manager.space.width;
  room.height = manager.space.height;

  manager.mainRoom = room;

  room.fixedZIndex = true;

  logger.merijn('wrap');

  {
    const props: Partial<TextObject2> = {
      defaultTextStyle: {
        color: COLORS.WHITE_100,
        fontSize: 440,
        fontId: 'font_regular',
        lineHeight: 1,
      },
      // textOverflow: 'wrap',
      // width: 1800,
      text: 'Travel Essence\nWishCollector',
    };
    const title = createAndAddLocalTextObject2(manager, getZeroStaticEntity(), props);
    manager.mainRoom.canvas.attachChild(title, manager.mainRoom.canvas);
    setEntityPosition(title, -1600, -1400);
  }

  {
    const mapProps: Partial<ImageEnt> = {
      maxWidthEm: 15,
    };
    const map = createImageEnt(manager, getZeroStaticEntity(), 'map1', mapProps);
    map.rotation = -0.04;
    manager.mainRoom.canvas.attachChild(map, manager.mainRoom.canvas);
    map.allowHighlight = true;
    map.allowDrag = true;
    setEntityPosition(map, -0, 50);
  }

  {
    const tableProps: Partial<ImageEnt> = {
      maxWidthEm: 100,
    };
    const table = createImageEnt(manager, getZeroStaticEntity(), 'table1', tableProps);
    manager.mainRoom.canvas.attachChild(table, manager.mainRoom.canvas);
  }
}

export function update() {}
